/**
 * Extended pattern from DOMPurify to allow "about" and "blob" schemes.
 * @see https://github.com/cure53/DOMPurify/blob/main/src/regexp.js#L9-L11
 */
export default // cspell:disable-next
/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|about|blob):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i;
